import { AutogenModelDistanceProfile, AutogenRowDistanceProfile } from "./autogen/AutogenModelDistanceProfile";

export class ModelDistanceProfile extends AutogenModelDistanceProfile<RowDistanceProfile> {
	constructor() {
		super(RowDistanceProfile);
	}
}

export class RowDistanceProfile extends AutogenRowDistanceProfile {
}